import React from "react";
import { styled } from "@mui/material/styles";

const SuggestionsContainer = styled('div')`
  width: 100%;
  min-height: 2em;
  display: flex;
  border-bottom: 2px solid #d8d8d852;
  padding: 6px 8px;
  align-items: center;
`;

const Thumbnail = styled('div')`
  width: auto;
  height: 100%;
  display: flex;
  flex: 0.4;

  img {
    width: auto;
    height: 100%;
  }
`;

const Name = styled('h3')`
  font-size: 15px;
  color: #000;
  margin-left: 10px;
  flex: 2;
  display: flex;
`;

const Segment = styled('h2')`
  font-size: 15px;
  color: #000;
  flex: 2;
  display: flex;
`;

// const Segment = styled('span')`
//   color: #a1a1a1;
//   font-size: 16px;
//   display: flex;
//   flex: 0.2;
// `;

export function Suggestions(props) {
  const { thumbanilSrc, reportName, name, segment } = props;

  return (
    <SuggestionsContainer>
      {/* <Thumbnail>
                <img src={thumbanilSrc} />
            </Thumbnail> */}
      <Name>{name}</Name>
      <Name>{reportName}</Name>
      <Segment>{segment || "N/A"}</Segment>
    </SuggestionsContainer>
  );
}